import type { FC } from "react";
import { useMenuProviderContext } from "../provider/MenuProvider";
import { HomeButton, SideNavContainer, SideNavItems } from "./SideNav.style";
import { useLocation, useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';

const SideNav:FC = () => {
    const menuItems = useMenuProviderContext()
    const location = useLocation()
    const navigate = useNavigate();
    const navigateToPage = (navEndPoint: string) => {
        navigate(navEndPoint);
    }
    return(

    <SideNavContainer>
        <HomeButton onClick={() => navigateToPage('/')}>
            <HomeIcon/>HOME
        </HomeButton>
        {menuItems.map((item) => <SideNavItems active = {item.navEndPoint === location.pathname} onClick={() => navigateToPage(item.navEndPoint)}>
            {item.menuItem}
        </SideNavItems>)}
    </SideNavContainer>
    );
}

export default SideNav;